// extracted by mini-css-extract-plugin
export default {"mapHistory":"LocationHistory_mapHistory__lKln6","popup":"LocationHistory_popup__EiwQ4"};